import CSS from 'csstype';
import { ALMOST_BLACK, MAIN } from 'static/config/worldVariables';
import styled from 'styled-components/macro';

interface Props {
    fontSize: ELabelTextSize;
    children: React.ReactNode;
    textAlign?: 'left' | 'center' | 'right';
    color?: string;
    style?: CSS.Properties;
    onClick?: () => void;
}

export const LabelText = (props: Props): JSX.Element => {
    function getFontSize() {
        switch (props.fontSize) {
            case ELabelTextSize.MINI:
                return '11px';
            case ELabelTextSize.SMALL:
                return '12px';
            case ELabelTextSize.MEDIUM:
                return '13px';
            case ELabelTextSize.BIG:
                return '14px';
            case ELabelTextSize.BIG2:
                return '15px';
            case ELabelTextSize.EXTRA:
                return '20px';
        }
    }
    function getLineHeight() {
        switch (props.fontSize) {
            case ELabelTextSize.MINI:
                return 'unset';
            case ELabelTextSize.SMALL:
                return 'unset';
            case ELabelTextSize.MEDIUM:
                return '19px';
            case ELabelTextSize.BIG:
                return 'unset';
            case ELabelTextSize.BIG2:
                return 'unset';
            case ELabelTextSize.EXTRA:
                return 'unset';
        }
    }

    return (
        <S_LabelText
            $size={getFontSize()}
            $lineHeight={getLineHeight()}
            $textAlign={props.textAlign ?? 'left'}
            $color={props.color ?? ALMOST_BLACK}
            style={props.style}
            onClick={props.onClick}
            $cursor={props.onClick ? 'pointer' : 'default'}
        >
            {props.children}
        </S_LabelText>
    );
};

export enum ELabelTextSize {
    MINI,
    SMALL,
    MEDIUM,
    BIG,
    BIG2,
    EXTRA
}

export const S_LabelText = styled.div<{
    $size: string;
    $textAlign: string;
    $lineHeight: string;
    $color: string;
    $cursor: string;
}>`
    font-size: ${(props) => props.$size};
    text-align: ${(props) => props.$textAlign};
    line-height: ${(props) => props.$lineHeight};
    color: ${(props) => props.$color};
    cursor: ${(props) => props.$cursor};
    a {
        color: ${MAIN};
        &:hover {
            text-decoration: underline;
        }
    }
`;
